import React from 'react';

import { Box, Text } from '@adsk/alloy-react-box';
import { ChartGanttIcon } from '@adsk/alloy-react-icon';
import StatusColorIndicator from '@adsk/alloy-react-status-color-indicator';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import EntityMenuItem from '../../../../../EntityMenuItem';
import { formatUniqueId } from '../../../helpers';
import { useScheduleActivityLink } from '../../hooks';
import { ActivityType, ScheduleActivityEntity } from '../../types';

const ScheduleActivityEntityItem = ({
  entity,
  ...rest
}: {
  entity: { id: string; activity: ScheduleActivityEntity };
}) => {
  const { activity } = entity;
  const { type, isCriticalPath, sequentialId, name } = activity;
  const scheduleActivityLink = useScheduleActivityLink(activity);

  const label = (
    <Box
      typography="bodyMedium"
      display="grid"
      alignItems="center"
      gridAutoFlow="column"
    >
      {type === ActivityType.Milestone && (
        <Box
          backgroundColor={isCriticalPath ? 'red300' : 'charcoal300'}
          borderRadius="2px"
          width="11px"
          height="11px"
          margin="0 8px 0 2px"
          style={{ transform: 'rotate(45deg)' }}
        />
      )}
      {isCriticalPath && type !== ActivityType.Milestone && (
        <StatusColorIndicator
          style={{
            width: '3px',
            height: '16px',
            marginRight: '8px',
            backgroundColor: theme.colors.red500,
          }}
        />
      )}
      <Text color="adskBlue700" marginRight="4px">
        {`#${formatUniqueId(sequentialId)}`}
      </Text>
      <OverflowTooltip
        style={{
          color: theme.colors.charcoal900,
          ...theme.typography.bodyMedium,
        }}
      >
        {name}
      </OverflowTooltip>
    </Box>
  );

  return (
    <EntityMenuItem
      {...rest}
      link={scheduleActivityLink}
      label={label}
      renderIcon={ChartGanttIcon.renderIcon}
    />
  );
};

export default ScheduleActivityEntityItem;
